define(function (require) {
	//views
	const sites_picker_list = require('./v_cpv_lp_list');

	//templates
	const tpl = require('./t_lov_location_picker.hbs');

	const TouchEvents = require('civicsUtils/mobile_utility');

	/********************************************************************* */
	/* 	IMPORTANT: This object is extended in location_selection_logic.	   */
	/*	If you can't find this.whatever in this file, look there.		   */
	/********************************************************************* */
	return Marionette.LayoutView.extend({
		className: "location-picker",
		extent: '',
		template: tpl,
		ui: {
			//sitesListDiv:'.site-list',
			mapOverlay:'.map-overlay-region',
			locationPickerRegion: '.location-picker-region',
			addressListRegionDiv:'.nearby-address-region',
			parcelListRegionDiv:'.nearby-parcel-region',
			assetListRegionDiv:'.nearby-asset-region',
			usePinLocationButton: '[name="use-pin-location"]',
			toggleMobileView:'.toggle-mobile-location-picker-view',
			closeModalButton: '.bbm-btn-close'

		},
		regions:{
			//sitesListRegion:'@ui.sitesListDiv',
			addressListRegion:'@ui.addressListRegionDiv',
			parcelListRegion:'@ui.parcelListRegionDiv',
			assetListRegion:'@ui.assetListRegionDiv'


		},
		events: {
			'click @ui.usePinLocationButton': 'usePinLocationClicked',

			'click @ui.closeModalButton':'beginCloseModal'
		},

		collectionEvents:{
			'update':'collectionChanged',
			'reset':'collectionChanged'
		},
		behaviors: {
			touchEvents: {
			  behaviorClass: TouchEvents,
			  targetClass: '.map-overlay-region',
			  direction: 'left'
			}
		  },

		childEvents: {
			'popup:close': 'beginCloseModal'		
		},

		activeMapLayers:null,
		initialize: function (options) {
			this.selectedSitesCollection = options.selectedSitesCollection;
			
		},
		onRender: function () {
			this.$el.rhythmThemeInitCivics();
			this.$el.rhythmThemeInit();
		},
		
		onShow: function () {
			this.showNearbySitesList();
		},
		usePinLocationClicked: function(e) {
			//retain current map clicked location
			let point =new Backbone.Model({
				Spatial:{
					xCoordinate:this.clickedPoint.x,
					yCoordinate:this.clickedPoint.y
				},
				_displayText:i18n.t('CIVICS.INSTRUMENT_SUBMIT.LOCATION.PINNED_LOCATION'),
				_siteType:'coords'
			})
			this.selectedSitesCollection.add(point);
			this.closeModal();
			e.preventDefault();

		},
		beginCloseModal:function(childView,options){
			this.ui.mapOverlay.removeClass('visible');
			//determine if we are currently transitioning our CSS
			let inTransition = window.getComputedStyle(this.ui.mapOverlay[0]).transitionDuration != '0s';
			if(inTransition){//mobile has a transition before teh view is off the screen. we need to wait to avoid visual glitches.
				this.ui.mapOverlay.on('transitionend',()=>{
					this.closeModal(options);
					this.ui.mapOverlay.off('transitionend');
				});
			} else {//desktop closes immediately. 
				this.closeModal(options);
			}
			
			//this.selectedSitesCollection.trigger('update');
		},
		closeModal:function(options){
			this.collection.reset();
			//when a site is selected, we don't need to update the collection - we already did by adding the model.
			if(!(options && options.siteSelected === true)){
				this.selectedSitesCollection.trigger('update');
			}
		},
		collectionChanged: function(model) {

			this.render();
			if(this.collection.length > 0)
				this.showNearbySitesList();
		},
		hasPrimarySite: function () {
			return this.selectedSitesCollection.primarySiteHiddenByConstraints || this.selectedSitesCollection.toJSON().find(site => site.primarySite === true);
		},
		noClosestSitesFound: function () {
			return this.collection.toJSON().find(site => site.clickLocationPin === true) && this.collection.length == 1;
		},
		showNearbySitesList:function(){
			if(this.collection.length==0){
				return;
			}
			let hasAssets =  this.collection.findWhere({_siteType:"asset"});
			let hasAddresses = this.collection.findWhere({_siteType:"address"});
			let hasParcels = this.collection.findWhere({_siteType:"parcel"});
			if(hasAddresses){
				this.addressListRegion.show(new sites_picker_list({
					collection:this.collection,
					selectedSitesCollection: this.selectedSitesCollection,
					siteType: 'address',
					headerRegion: i18n.t('CIVICS.INSTRUMENT_SUBMIT.LOCATION.ADDRESS')
				}));
	
			}
			if(hasParcels){
				this.parcelListRegion.show(new sites_picker_list({
					collection:this.collection,
					selectedSitesCollection: this.selectedSitesCollection,
					siteType: 'parcel',
					headerRegion: i18n.t('CIVICS.INSTRUMENT_SUBMIT.LOCATION.PARCEL')
				}));
			}
			if(hasAssets){	
				let assetTypes = [];			
				this.collection.each((site)=>{
				if(site.get('_siteType') == 'asset' && !assetTypes.includes(site.get('assetType'))){
					assetTypes.push(site.get('assetType'));
					this.createAssetRegion(site.get('typeDisplayText'));
				}
			})

			}

			window.setTimeout(()=>{
			this.ui.mapOverlay.addClass('visible');
			},100);

		},
		createAssetRegion: function(type){
			let selector = type.replace(/\s/g, "");
			let region = 'assetListRegionDiv';
			this.ui[region].append('<div class="' + selector + '">');
		    this.addRegion(selector+'Region', '.' + selector);
			this[selector+'Region'].show(new sites_picker_list({
				collection:this.collection,
				selectedSitesCollection: this.selectedSitesCollection,
				siteType: 'asset',
				assetType: type,
				headerRegion: type
			}));
		},
		templateHelpers: function () {
			return {
				headerText: !this.hasPrimarySite() ?  
					i18n.t('CIVICS.INSTRUMENT_SUBMIT.PRIMARY_SITE') : 
					i18n.t('CIVICS.INSTRUMENT_SUBMIT.LOCATION.ADDITIONAL_SITES'),
				descriptionText:()=>{
					if(!this.hasPrimarySite() && this.collection && this.collection.length==0){
						return i18n.t('CIVICS.INSTRUMENT_SUBMIT.LOCATION.NO_SITE_FOUND_USE_PIN');
					} else if(this.noClosestSitesFound()){
						return i18n.t('CIVICS.INSTRUMENT_SUBMIT.LOCATION.NO_SITE_FOUND_TRY_AGAIN');
					} else {
						return i18n.t('CIVICS.INSTRUMENT_SUBMIT.LOCATION.SITE_FOUND_CHOOSE_BELOW');
					}				
				},
				hiddenCSSClass: this.collection && this.collection.length>0 ? '':' hidden',
				noPrimarySiteSelected:!this.hasPrimarySite()
			}	
		}
	});
})
